export enum ProviderInformationCollectionDetailsResultIssue {
  specialty1Blank = 'specialty1_blank',
  faxNumbersBlank = 'fax_numbers_blank',
  faxNumberInvalid = 'fax_number_invalid',
  taskExpired = 'task_expired',
}
